import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StitchingtaskEditFormImpl from './StitchingtaskEditFormImpl';
import StitchingtaskList from './StitchingtaskList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StitchingtaskListView from './StitchingtaskListView'


export default function StitchingtaskDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);
  const [ stitchingtaskId, setStitchingtaskId] = React.useState('');
  const [reloadStitchingtaskList, setReloadStitchingtaskList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StitchingtaskEditFormImpl 
            setReloadStitchingtaskList={setReloadStitchingtaskList}
            stitchingtaskId={stitchingtaskId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StitchingtaskListView 
                      setStitchingtaskId = {setStitchingtaskId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
